
import { defineComponent, PropType } from 'vue'

// Components
import TheButton from '@/common/components/UI/TheButton/index.vue'

// Types
import { DeliveryProductT } from '@/core/types/delivery.types'

export default defineComponent({
    components: {
        'the-button': TheButton,
    },
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        products: {
            type: Array as PropType<DeliveryProductT[]>,
            default: () => [],
        },
        receiverIdx: {
            type: Number,
            default: null,
        },
    },
    emits: ['remove'],
    setup(props, { emit }) {
        const emitRemove = (product_index: number) => {
            const answer = confirm(
                `Вы уверены что хотите удалить товар '${props.products[product_index].title}?'`
            )
            if (!answer) return

            const payload = { product_index, receiver_idx: props.receiverIdx }

            emit('remove', payload)
        }

        return { emitRemove }
    },
})
